<template>
  <!-- 这个页面应该可以整个注释吧，路由里的指向路径也可以删除了，应该没有用到 -->
  <div>
    <GlobalHead />
    <div class="allWrapper">
      <div class="guideHeader">
        <div class="guidHeaderMain">
          <div class="headLeft">
            <span class="formTitle">某某建设和住房管理局</span>
            <span class="title">房屋租赁备案登记</span>
            <span class="ownTitle">个人、法人、行政机关、其他组织</span>
            <div class="titleBtn">
              <span class="btnStyle1">在线办理</span>
              <span class="btnStyle2">预约办理</span>
              <span style="font-size:16px;margin-left:16px;cursor: pointer;" @click="downGuide">
                <a-icon style="color:#1777ff" :component="IconDownload"></a-icon> 下载指南
              </span>
            </div>
          </div>
          <div class="headeRight">
            <div class="headRightTag">
              <span class="cont">不收费</span>
              <span class="cont">即办件</span>
              <span class="cont">全程网办</span>
            </div>
            <div class="workTime">
              <span class="workSpan">
                <div class="dayStyle"><span class="dayStyleTime">20</span><span class="dayStyleDesc">工作日</span></div>
                <div class="desStyle">法定办结时限</div>
              </span>
              <span class="workSpan">
                <div class="dayStyle"><span class="dayStyleTime">1</span><span class="dayStyleDesc">工作日</span></div>
                <div class="desStyle">承诺办结时限</div>
              </span>
            </div>
            <span class="toOtherStyle" @click="toSimple">
              查看简洁版办事指南 >
            </span>

          </div>
        </div>
      </div>
      <div class="simpleMain">
        <div class="section1">
          <a-tabs default-active-key="1">
            <a-tab-pane key="1">
              <template slot="tab">
                <a style="font-size: 18px;color:#999;display: inline-block;padding:12px 16px" href="#eventMessage">事项信息</a>
              </template>
            </a-tab-pane>
            <a-tab-pane key="2">
              <template slot="tab">
                <a style="font-size: 18px;color:#999;display: inline-block;padding:12px 16px" href="#handleFlow">办理流程</a>
              </template>
            </a-tab-pane>
            <a-tab-pane key="3">
              <template slot="tab">
                <a style="font-size: 18px;color:#999;display: inline-block;padding:12px 16px" href="#matrialSection">办事材料</a>
              </template>
            </a-tab-pane>
            <a-tab-pane key="4">
              <template slot="tab">
                <a style="font-size: 18px;color:#999;display: inline-block;padding:12px 16px" href="#setRules">设定依据</a>
              </template>
            </a-tab-pane>
            <a-tab-pane key="5">
              <template slot="tab">
                <a style="font-size: 18px;color:#999;display: inline-block;padding:12px 16px" href="#commonQuestion">常见问题</a>
              </template>
            </a-tab-pane>
          </a-tabs>
        </div>
        <div class="section2">
          <div class="sectionLeft">
            <EventMessage id="eventMessage" style="margin-bottom:40px" />
            <HandleFlow id="handleFlow" style="margin-bottom:40px" />
            <MatrialSection id="matrialSection" />
            <SetRules style="margin-top:40px" id="setRules" />
            <div class="commonQuestion" id="commonQuestion" style="width:800px;padding-bottom:20px">
              <div class="title">常见问题</div>
              <div style="margin-top:20px" v-for="item in mockData" :key="item.id">
                <div>

                  <div class="headerTitle" style="">
                    <span>{{ item.question }}</span>
                    <div style="float:right">
                      <span v-show="item.isAnswerShow" @click="answerShowChanges(item)" style="color:#999;font-size:14px;cursor: pointer;">收起∧</span>
                      <span v-show="!item.isAnswerShow" @click="answerShowChanges(item)" style="color:#999;font-size:14px;cursor: pointer;">展开∨</span>
                    </div>
                  </div>
                  <transition>
                    <div v-show="item.isAnswerShow" style="font-size: 14px;color: #666666;padding-left:10px;margin-top:12px">
                      {{ item.answer }}
                    </div>
                  </transition>
                </div>
              </div>
            </div>
          </div>
          <div class="sectionRight">
            <IsCharge style="margin-bottom:20px" />
            <Consulting style="margin-bottom:20px" />
            <HandlePlace />
          </div>
        </div>
      </div>
    </div>
    <!-- <GlobalFoot /> -->
    <h-download ref="hDownload" :hrefUrl="hrefUrl"></h-download>
    <FlowMessage ref="flowMessage" />
  </div>
</template>

<script>
import GlobalHead from '@/views/layout/globalHead.vue'
// import GlobalFoot from '@/views/layout/globalFood.vue'
import IconDownload from '@ant-design/icons/svg/outline/download.svg?inline'
import messageIcon from '@/assets/jiopweb3.0.0/message.svg?inline'
import rigthIcon from './../../../assets/jiopweb3.0.0/you.svg?inline'
import FlowMessage from './components/flowMessage.vue'
import MatrialSection from './components/matrialSection.vue'
import Consulting from './components/consulting.vue'
import HandlePlace from './components/handlePlace.vue'
import SetRules from './components/setRules.vue'
import IsCharge from './components/isCharge.vue'
import EventMessage from './components/publicMessage.vue'
import HandleFlow from './components/handleFlow.vue'
import { HDownload } from 'jpaas-component'
export default {
  name: 'PublicService',
  components: {
    GlobalHead,
    // GlobalFoot,
    HDownload,
    FlowMessage,
    MatrialSection,
    Consulting,
    HandlePlace,
    SetRules,
    IsCharge,
    EventMessage,
    HandleFlow
  },
  data () {
    return {
      hrefUrl: '',
      mockData: [
        {
          id: 1,
          isAnswerShow: true,
          question: '是否可以委托他人办理',
          answer: '可以。委托人需在材料处下载并填写《委托书》，被委托人应持自身居民身份证件前来办理。'
        },
        {
          id: 2,
          isAnswerShow: false,
          question: '是否拥有绝对主导权',
          answer: '客观上说拥有，主观上不确定'
        },
        {
          id: 3,
          isAnswerShow: false,
          question: '是否能成长',
          answer: '可以。做大做强，再创辉煌！！！'
        }
      ],
      IconDownload,
      messageIcon,
      rigthIcon
    }
  },
  methods: {
    answerShowChanges (value) {
      this.mockData = this.mockData.map(item => {
        if (item.id === value.id) {
          item.isAnswerShow = !item.isAnswerShow
        }
        return item
      })
    },
    toSimple () {
      const url = this.$router.resolve({ path: '/guideSimple', query: { bannerType: this.$route.query.bannerType } })
      window.open(url.href, '_blank')
    },
    // 下载指南
    downGuide () {
      this.hrefUrl = ''
      this.$refs.hDownload.download()
    },
    flowSeeOpen () {
      this.$refs.flowMessage.open()
    }
  }
}
</script>

<style lang="less" scoped>
::v-deep .ant-tabs-nav .ant-tabs-tab-active a {
  color: #1890ff !important;
}
::v-deep .ant-tabs-nav .ant-tabs-tab {
  padding: 0 0 !important;
}
.v-enter,
.v-leave-to {
  opacity: 0;
  transform: translateY(-20px);
}
.v-enter-active,
.v-leave-active {
  transition: all 0.4s ease;
}
.allWrapper {
  .guideHeader {
    padding-top: 25px;
    box-sizing: border-box;
    height: 300px;
    background: #f3f7ff;
    .guidHeaderMain {
      width: 1200px;
      margin: 0 auto;
      .headLeft {
        float: left;
        width: 50%;
        .formTitle {
          font-size: 16px;
          color: #666666;
          line-height: 30px;
          height: 30px;
          display: inline-block;
          padding: 0 10px;
          background-image: linear-gradient(270deg, #f3f7ff 0%, #c8ddfb 99%);
          border-radius: 18px;
          margin-top: 28px;
        }
        .title {
          display: block;
          margin-top: 14px;
          font-size: 40px;
          line-height: 40px;
          color: #333333;
          font-weight: bold;
        }
        .ownTitle {
          display: block;
          margin-top: 8px;
          font-size: 14px;
          color: #333333;
        }
        .titleBtn {
          margin-top: 24px;
          .btnStyle2 {
            height: 40px;
            width: 110px;
            margin-left: 20px;
            line-height: 40px;
            text-align: center;
            border: 1px solid rgba(23, 119, 255, 1);
            border-radius: 4px;
            cursor: pointer;
            display: inline-block;
            font-size: 14px;
            color: #1777ff;
          }
          .btnStyle1 {
            height: 40px;
            display: inline-block;
            width: 110px;
            color: #fff;
            background: #1777ff;
            line-height: 40px;
            text-align: center;
            border: 1px solid #fff;
            border-radius: 4px;
            cursor: pointer;
            font-size: 14px;
          }
        }
      }
      .headeRight {
        float: right;
        width: 50%;
        text-align: right;
        .headRightTag {
          margin-top: 20px;
          .cont {
            display: inline-block;
            line-height: 40px;
            text-align: center;
            width: 100px;
            height: 40px;
            font-size: 16px;
            color: #333333;
            font-weight: bold;
            margin-left: 20px;
            border: 1px solid rgba(22, 119, 255, 1);
            border-radius: 25px;
          }
        }
        .workTime {
          margin-top: 16px;
          .workSpan {
            display: inline-block;
            margin-left: 12px;
            margin-right: 8px;
            .dayStyle {
              .dayStyleTime {
                font-size: 28px;
                color: #1677ff;
                letter-spacing: 0;
                line-height: 28px;
                font-weight: 700;
              }
              .dayStyleDesc {
                margin-left: 8px;
                font-size: 16px;
                color: #333333;
                letter-spacing: 0;
                line-height: 16px;
                font-weight: 500;
              }
            }
            .desStyle {
              margin-top: 6px;
              font-size: 14px;
              color: #999999;
              letter-spacing: 0;
              line-height: 14px;
              font-weight: 400;
            }
          }
        }
        .toOtherStyle {
          margin-top: 16px;
          cursor: pointer;
          display: inline-block;
          width: 219px;
          height: 60px;
          background-image: linear-gradient(135deg, #f1f6f8 0%, #feffff 100%);
          border: 3px solid rgba(255, 255, 255, 1);
          box-shadow: 0px 4px 14px 0px rgba(181, 211, 229, 0.6);
          border-radius: 8px;
          font-size: 16px;
          line-height: 54px;
          text-align: center;
          color: #1777ff;
        }
      }
    }
  }
  .commonQuestion {
    margin-top: 40px;
    .title {
      font-size: 22px;
      color: #333333;
      font-weight: 500;
    }
    .headerTitle {
      color: #333;
      font-weight: bold;
      height: 40px;
      line-height: 40px;
      font-size: 16px;
      padding-left: 10px;
      background-image: linear-gradient(270deg, rgba(196, 210, 240, 0) 0%, #dfe7fa 100%);
      border-radius: 4px;
    }
  }
  .simpleMain {
    width: 1200px;
    margin: 0 auto;
    .section2 {
      overflow: hidden;
      margin-top: 40px;
      .sectionLeft {
        float: left;
        width: 800px;
        margin-bottom: 15px;
        .resultStyle {
          margin-top: 40px;
          .title {
            font-size: 22px;
            color: #333333;
            font-weight: 500;
          }
          .textFlow {
            display: -webkit-box;
            -webkit-box-orient: vertical;
            -webkit-line-clamp: 2;
            overflow: hidden;
          }
          .swiper-slide {
            cursor: pointer;
          }
        }
      }
      .sectionRight {
        float: right;
        width: 360px;
      }
    }
  }
}
</style>
